import { memo, useMemo } from 'react';
import pathToRegexp from 'path-to-regexp';

import moment from 'moment';
import { Link } from 'react-router-dom';

import { ROUTE_GROUP_SETTINGS } from 'constant/routes';
import { pluralize } from 'utils';

import { getGroupCounts } from './utils';
import { WorkflowGroupsQueryQuery } from '@/apollo/graphql';
import { AvatarComponent } from '@/components/ui/avatar/avatar';

type Props = {
  group: NonNullable<
    NonNullable<
      WorkflowGroupsQueryQuery['workflowByRowId']
    >['groups']['nodes'][number]
  >;
};
/**
 * A single group card linking to the group's page
 */
export const GroupCard = memo(({ group }: Props) => {
  const { teams, users, bots } = useMemo(
    () => getGroupCounts(group.members.nodes),
    [group.members.nodes]
  );

  return (
    <Link
      to={pathToRegexp.compile(ROUTE_GROUP_SETTINGS)({ id: group.rowId })}
      className="text-muted-foreground bg-card group border-border hover:border-input hover:bg-card-hover grid grid-cols-5 gap-2 overflow-hidden rounded-md border px-5 py-2"
    >
      <div className="col-span-3 flex h-full flex-row flex-nowrap items-center gap-3">
        <AvatarComponent source={group.avatar} name={group.name} />
        <div className="text-foreground flex flex-col flex-nowrap items-start truncate text-sm capitalize">
          {group.name}
        </div>
      </div>
      <div className="flex h-full items-center justify-end text-xs sm:mt-0">
        {`Created on ${moment(group.createdAt).format('dddd, Do MMMM YYYY')}`}
      </div>
      <div className="flex h-full items-center justify-end text-xs sm:mt-0">
        {pluralize(users + bots, 'participant', false, true)},{' '}
        {pluralize(teams, 'team', false, true)}
      </div>
    </Link>
  );
});
